"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _elements = require("../../elements");

var _ModalHeader;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Sheets = _ref => {
  let {
    className,
    prefix,
    children,
    open,
    closeBtnClick,
    header,
    alignment,
    preserveAlignment,
    footer,
    size,
    ariaCloseTxt,
    ...rest
  } = _ref;
  const classes = (0, _classnames.default)(`${prefix}sheets`, `${prefix}sheets--${size}`, alignment === 'left' && `${prefix}sheets--mirrored`, preserveAlignment && `${prefix}sheets--preserve-alignment`, open ? `${prefix}sheets--enter` : `${prefix}sheets--close`, className);

  const hookedHeader = _react.default.cloneElement(header || _ModalHeader || (_ModalHeader = _react.default.createElement(_elements.ModalHeader, null)), {
    closeBtnClick,
    prefix,
    ariaCloseTxt
  });

  const hookedFooter = footer && _react.default.cloneElement(footer, {
    prefix,
    closeBtnClick
  }) || null;

  const hookedBody = _react.default.Children.map(children, child => child.props ? _react.default.cloneElement(child, {
    prefix
  }) : child);

  return _react.default.createElement("div", _extends({}, rest, {
    className: classes,
    "aria-modal": "true",
    role: "dialog",
    tabIndex: "-1"
  }), !hookedHeader.props.floating && hookedHeader, _react.default.createElement("div", {
    className: `${prefix}sheets__content-wrapper`,
    tabIndex: "0"
  }, _react.default.createElement("div", null, " ", hookedHeader.props.floating && hookedHeader, hookedBody)), hookedFooter);
};

Sheets.defaultProps = {
  open: false,
  prefix: '',
  ariaCloseTxt: 'Close modal',
  size: 'small',
  alignment: 'right',
  preserveAlignment: false
};
var _default = Sheets;
exports.default = _default;